<template>
    <div>
        <Box @close="close({})">
            <template #top>Nueva Devolución</template>
            <template #center>
                <div class="nj-panel">
                    <div class="nj-panel-content">
                        <SearchBox label="Solicitante"
                                   itemKey="epr_id"
                                   :source="solicitantes"
                                   id="di-items"
                                   :searchFunction="buscarEmpleadoxNombre"
                                   @selectItem="seleccionarSolicitante($event)">
                            <template #default="data">
                                {{ data.item.emp_nombre_completo }} ( {{ data.item.pry_nombre }} )
                            </template>
                        </SearchBox>
                        <br>
                        <b-table :data="lista_asignacion_items_detalle">
                            <template slot-scope="props">
                                <b-table-column label="Producto"
                                                header-class="is-info">{{ props.row.prv_nombre }}</b-table-column>
                                <b-table-column label="Autorizador"
                                                header-class="is-info">{{ props.row.emp_autorizador_nombre
                                                }}</b-table-column>
                                <b-table-column label="Solicitante"
                                                header-class="is-info">{{ props.row.emp_solicitante_nombre
                                                }}</b-table-column>
                                <b-table-column label="Cantidad asignada"
                                                header-class="is-info"
                                                style="width: 80px;">{{ props.row.aid_cantidad }}</b-table-column>
                                <b-table-column label="Cantidad a devolver"
                                                header-class="is-info"
                                                style="width: 80px;">
                                    <input type="text"
                                           class="nj-text"
                                           v-model="props.row.did_cantidad">
                                </b-table-column>
                                <b-table-column label="Retorno (días)"
                                                header-class="is-info"
                                                style="width: 80px;">{{ props.row.prv_retorno_estimado
                                                }}</b-table-column>
                                <b-table-column label="Notas"
                                                header-class="is-info">
                                    <input type="text"
                                           class="nj-text"
                                           v-model="props.row.did_notas">
                                </b-table-column>
                            </template>
                        </b-table>
                        <!-- <div v-if="lista_asignacion_items_detalle">
                        <div class="nj-data-grid-header asignaciones">
                            <div>N°</div>
                            <div>Producto</div>
                            <div>Autorizador</div>
                            <div>Solicitante</div>
                            <div>Cantidad asignada</div>
                            <div>Cantidad a devolver</div>
                            <div>Retorno (días)</div>
                            <div>Notas</div>
                        </div>
                        <div class="nj-data-grid-content asignaciones" v-for="item in lista_asignacion_items_detalle" :key="item.aid_id">
                            <div>{{ item.asi_id }}</div>
                            <div>{{ item.prv_nombre }}</div>
                            <div>{{ item.emp_autorizador_nombre }}</div>
                            <div>{{ item.emp_solicitante_nombre }}</div>
                            <div>{{ item.aid_cantidad }}</div>
                            <div>
                                <input type="text" class="nj-text" v-model="item.did_cantidad">
                            </div>
                            <div>{{ item.prv_retorno_estimado }}</div>
                            <div>
                                <input type="text" class="nj-text" v-model="item.did_notas">
                            </div>
                        </div>
                    </div> -->
                    </div>
                </div>
            </template>
            <template #bottom>
                <Button label="Registrar"
                        icon="save"
                        @click="registrar()"></Button>
            </template>
        </Box>
    </div>
</template>

<script>
import { AsignacionItemsService, DevolucionItemsService, EmpleadoService, ResponseStatus, UsuarioService } from "../../services"
import Toast from "../../util/toast"
import { Box, Button, InputSelect, InputText, SearchBox } from "../components"

export default {
    name: "RegistrarDevolucionItems",
    components: {
        Box,
        InputText,
        InputSelect,
        SearchBox,
        Button,
    },
    data() {
        return {
            devolucion_items: {
                asi_id: null,
                usu_registrador: UsuarioService.getUsuario().usu_id,
                lista_devolucion_items_detalle: []
            },
            emp_solicitante: null,
            emp_solicitante_nombre: null,
            solicitantes: [],
            lista_asignacion_items_detalle: [],
        }
    },
    methods: {
        close({
            view = "",
            buscar = false
        }) {
            this.reiniciarBusquedas()
            this.$emit("close", {
                view,
                buscar
            })
        },
        reiniciarBusquedas() {
            this.solicitantes = []
        },
        buscarEmpleadoxNombre(emp_nombre_completo) {
            DevolucionItemsService
                .buscarEmpleadoxNombre({
                    empleado: {
                        emp_nombre_completo,
                        pry_id: UsuarioService.getProject(),
                    }
                })
                .then(response => {
                    this.solicitantes = response.data
                })
                .catch(error => {
                    Toast.error(error)
                })
        },
        seleccionarSolicitante(solicitante) {
            console.warn("solicitante.pry_id", solicitante.pry_id)
            // asignando el id del proyecto a la devolucion
            this.devolucion_items.pry_id = solicitante.pry_id
            AsignacionItemsService
                .buscarDetalle({
                    asignacion_items_detalle: {
                        pry_id: solicitante.pry_id,
                        emp_solicitante: solicitante.emp_id
                    }
                })
                .then(response => {
                    if (ResponseStatus.isSuccess(response)) {
                        this.lista_asignacion_items_detalle = response.data
                        this.lista_asignacion_items_detalle.forEach(item => {
                            item.did_cantidad = item.aid_saldo
                            item.did_notas = null
                        })
                    }
                    else {
                        Toast.error(response.message)
                    }
                })
                .catch(error => {
                    Toast.error(error)
                })
        },
        registrar() {
            this.lista_asignacion_items_detalle.forEach(item => {
                if (!this.devolucion_items.asi_id) {
                    this.devolucion_items.asi_id = item.asi_id
                }
                this.devolucion_items.lista_devolucion_items_detalle.push({
                    aid_id: item.aid_id,
                    aid_cantidad: item.aid_cantidad,
                    did_cantidad: item.did_cantidad,
                    did_notas: item.did_notas,
                    pal_id: item.pal_id
                })
            })
            DevolucionItemsService
                .registrar({
                    devolucion_items: this.devolucion_items
                })
                .then(response => {
                    if (ResponseStatus.isSuccess(response)) {
                        Toast.success(response.message)
                        this.close({
                            buscar: true
                        })
                    }
                    else {
                        Toast.error(response.message)
                    }
                })
                .catch(error => {
                    Toast.error(error)
                })
        },
    },
    mounted() {

    }
}
</script>

<style scoped>
.asignaciones {
    grid-template-columns: 60px 1fr 1fr 1fr 80px 100px 60px 1fr;
}
</style>